"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initTimeline = void 0;
const makePID_1 = require("./makePID");
const appTimer_1 = require("./appTimer");
const initTimeline = (config, enterFullscreen) => {
    const initialTimeline = [enterFullscreen];
    const beginningTimeline = {
        timeline: initialTimeline,
        on_timeline_finish: async () => {
            await config.firekit.updateUser({
                assessmentPid: config.pid || (0, makePID_1.makePid)(),
                ...config.userMetadata,
            });
            (0, appTimer_1.startAppTimer)(config.maxTime);
        },
    };
    return beginningTimeline;
};
exports.initTimeline = initTimeline;
